import { render, staticRenderFns } from "./in-person-logs.vue?vue&type=template&id=1d97f0b3"
import script from "./in-person-logs.vue?vue&type=script&lang=js"
export * from "./in-person-logs.vue?vue&type=script&lang=js"
import style0 from "./in-person-logs.vue?vue&type=style&index=0&id=1d97f0b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports